const certifications = [
  {
    id: 1,
    title: "Informática Profissional",
    issuer: "People",
    date: "Março 2018",
    credential: "MAT-5101",
    image: `${window.location.origin}/assets/images/cert/informatica.jpg`,
    description: "Windows, Internet, Edição e criação de Vídeos, Microsoft Office.",
    category: 'tech'
  },
  {
    id: 2,
    title: "Gestão Administrativa",
    issuer: "People",
    date: "Março 2018",
    credential: "MAT-5101",
    image: `${window.location.origin}/assets/images/cert/adm.jpg`,
    description: "Administrativo, Atendimento ao Cliente, Marketing e Vendas, Departamento Pessoal, Contabilidade e Consultor de Vendas.",
    category: 'tech'
  },
  {
    id: 3,
    title: "Inglês Intermediário",
    issuer: "People",
    date: "Dezembro 2017",
    credential: "MAT-2428",
    image: `${window.location.origin}/assets/images/cert/ingles.jpg`,
    description: "Startup, Annual Book 2, Annual Book 4.",
    category: 'language'
  },
  {
    id: 4,
    title: "Hardware Master",
    issuer: "People",
    date: "Julho 2018",
    credential: "MAT-5101",
    image: `${window.location.origin}/assets/images/cert/hardware.jpg`,
    description: "Fundamentos de Hardware, Elétrica, Eletrônica, Roteadores e Modens e Programação de Software.",
    category: 'tech'
  },
  {
    id: 5,
    title: "Digitação",
    issuer: "People",
    date: "Julho 2018",
    credential: "MAT-5101",
    image: `${window.location.origin}/assets/images/cert/digitacao.jpg`,
    description: "Digitação avançada.",
    category: 'tech'
  },
  {
    id: 6,
    title: "Inteligência Emocional",
    issuer: "Cefis",
    date: "Junho 2024",
    credential: "MAT-NONE",
    image: "/cert6.jpg",
    description: "Felicidade, Conceitos, Inteligência emocional, Emoção x Sentimentos, O cérebro, Habilidades na IE, Neurotransmissores da felicidade, Emoção x Produtividade, Raiva e Estresse.",
    category: 'brain'
  },
  {
    id: 6,
    title: "Fundamentos de Logística",
    issuer: "Senai São Paulo",
    date: "Outubro 2023",
    credential: "MAT-NONE",
    image: `${window.location.origin}/assets/images/cert/logistica.jpg`,
    description: "Contexto histórico do transporte no Brasil, Modalidade de Transporte, Sistemas de Transporte, Modal Rodoviário, Modal Ferroviário, Modal Aquaviário, Modal Dutoviário, Modal Aéreo, Gestão da Qualidade e Logística de Almoxarifado.",
    category: 'logistics'
  },
  {
    id: 6,
    title: "RGPB/LGPD",
    issuer: "Senai CTTI MG",
    date: "Agosto 2023",
    credential: "MAT-NONE",
    image: `${window.location.origin}/assets/images/cert/lgpd.jpg`,
    description: "Regulamento geral sobre a proteção de dados (RGPD), Práticas de governança e Segurança e Privacidade.",
    category: 'tech'
  }
];

export default certifications